const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

/**
 * Utility function to convert Date into human readable form.
 *
 * E.g.: Jan 1, 2021
 *
 * @param date - Date to be transformed.
 */
export const transformDateString = (date: Date): string => {
    const month = date.getUTCMonth();
    const day = date.getUTCDate();
    const year = date.getUTCFullYear();

    return `${months[month].substring(0, 3)} ${day}, ${year}`;
};
